import { render } from "./SiteLayout.vue?vue&type=template&id=2b7d68f8&scoped=true"
import script from "./SiteLayout.vue?vue&type=script&lang=js"
export * from "./SiteLayout.vue?vue&type=script&lang=js"

import "./SiteLayout.vue?vue&type=style&index=0&id=2b7d68f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7d68f8"]])

export default __exports__